import { createI18n } from 'vue-i18n'
import { translations as DE } from './translations/de/translations'
import { translations as EN } from './translations/en/translations'
import { translations as RU } from './translations/ru/translations'
import { translations as RO } from './translations/ro/translations'
import { translations as DA } from './translations/da/translations'
import { translations as PL } from './translations/pl/translations'
import { translations as AR } from './translations/ar/translations'
import { translations as BG } from './translations/bg/translations'
import { translations as CS } from './translations/cs/translations'
import { translations as ES } from './translations/es/translations'
import { translations as PT } from './translations/pt/translations'
import { translations as FR } from './translations/fr/translations'
import { translations as HU } from './translations/hu/translations'
import { translations as IT } from './translations/it/translations'
import { translations as NL } from './translations/nl/translations'
import { translations as SK } from './translations/sk/translations'
import { translations as TR } from './translations/tr/translations'

export type TLanguageCodes =
  | 'de'
  | 'en'
  | 'ru'
  | 'ro'
  | 'da'
  | 'pl'
  | 'tr'
  | 'ar'
  | 'bg'
  | 'cs'
  | 'es'
  | 'pt'
  | 'fr'
  | 'hu'
  | 'it'
  | 'nl'
  | 'sk'

export function isSupportedLanguageCode(code: string): code is TLanguageCodes {
  return [
    'de',
    'en',
    'ru',
    'ro',
    'da',
    'pl',
    'tr',
    'ar',
    'bg',
    'cs',
    'es',
    'pt',
    'fr',
    'hu',
    'it',
    'nl',
    'sk',
  ].includes(code as TLanguageCodes)
}

/**
 * Transforms a simple language code into locale format required by Capacitor features (like speech recognition)
 * @param code Simple language code (e.g. 'de', 'en')
 * @returns Locale format (e.g. 'de-DE', 'en-US')
 */
export function getLocaleFromLanguageCode(code: string): string {
  const localeMap: Record<string, string> = {
    de: 'de-DE', // German
    en: 'en-US', // English (US)
    ru: 'ru-RU', // Russian
    ro: 'ro-RO', // Romanian
    da: 'da-DK', // Danish
    pl: 'pl-PL', // Polish
    tr: 'tr-TR', // Turkish
    ar: 'ar-SA', // Arabic (Saudi Arabia as default)
    bg: 'bg-BG', // Bulgarian
    cs: 'cs-CZ', // Czech
    es: 'es-ES', // Spanish (Spain)
    pt: 'pt-PT', // Portuguese (Portugal)
    fr: 'fr-FR', // French (France)
    hu: 'hu-HU', // Hungarian
    it: 'it-IT', // Italian
    nl: 'nl-NL', // Dutch
    sk: 'sk-SK', // Slovak
  }

  return localeMap[code] || 'en-US' // Default to en-US if code not found
}

export const translations = {
  de: DE,
  en: EN,
  ru: RU, //Russian
  ro: RO, //Romanian
  da: DA, //Danish
  pl: PL, //Polish
  tr: TR, //Turkish
  ar: AR, //Arabic
  bg: BG, //Bulgarian
  cs: CS, //Czech
  es: ES, //Spanish
  pt: PT, //Portuguese
  fr: FR, //French
  hu: HU, //Hungarian
  it: IT, //Italian
  nl: NL, //Dutch
  sk: SK, //Slovak
}

export const languageNames = {
  de: 'Deutsch',
  en: 'English',
  ru: 'Русский',
  ro: 'Română',
  da: 'Dansk',
  pl: 'Polski',
  tr: 'Türkçe',
  ar: 'العربية',
  bg: 'български език',
  cs: 'čeština',
  es: 'Español',
  pt: 'Português',
  fr: 'Français',
  hu: 'Magyar',
  it: 'Italiano',
  nl: 'Nederlands',
  sk: 'Slovenčina',
}

export const i18nInstance = createI18n({
  locale: 'de',
  legacy: false,
  fallbackLocale: 'de',
  messages: translations,
  missingWarn: false,
  fallbackWarn: false,
})

export const i18n = i18nInstance.global
